import { addRenderDataType, addRenderTypeByData, deleteRenderDataType, downloadRenderDataBackup, exportRenderData, getRenderDataTypeList, newDownloadBackup, updateRenderDataType } from "@/api/geometry/primitive";
import SideBarTool from "@/commons/components/side-bar-tool";
import { SideBarBtnType } from "@/commons/enums/side-bar-btn-type";
import { RenderDataType } from "@/commons/interface/geometry/primitive";
import { Button, Input, Spin, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ContextMenuFC, DragModal } from "tncet-common";
import "./index.less"
import classNames from "classnames";
import { getRenderDataJson } from "@/commons/utils/model-utils";
import { getProjectDetail } from "@/api/project/project";
import dayjs from "dayjs";
import { BlockT, DcalignedT, DclinearT, MeshBaseT, ModelBase, TnEngineExtraContext } from "pytha";
import { findLayersInProjectUuid } from "@/api/geometry/layer";
import { Layer } from "@/commons/interface/geometry/layer";
import genUUID from "@/commons/utils/gen-uuid";
import { BufferGeometry } from "three";
import { getGroups } from "@/api/spec-common/group";
import { Group } from "@/commons/interface/speccommon/group";
import { GroupType } from "tnbimbase";

export const SpecialLayerNamePrefix = {
    means_of_escape: '逃生通道',
    escape_guide_arrow: '逃生指引箭头',
    floor: '楼板',
}
export enum SpecialLayerType {
    /**
     * 逃生通道
     */
    means_of_escape,
    /**
     * 逃生指引箭头
     */
    escape_guide_arrow,
    /**
     * 楼板
     */
    floor,
}

export default function RenderDataPanel() {

    const { projectUuid, modelUuid } = useParams();
    const [activeItemUuid, setActiveItemUuid] = useState<string>("")
    const [typeList, setTypeList] = useState<RenderDataType[]>([])
    const [visible, setVisible] = useState<boolean>(false)
    const [nameValue, setNameValue] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)

    const [cmTop, setCmTop] = useState<number>();   //下拉框上方定位
    const [cmLeft, setCmLeft] = useState<number>(); //下拉框左侧定位
    const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false); // 右键菜单是否打开

    useEffect(() => {
        if (!projectUuid || !modelUuid) return
        generateData()
    }, [])

    const generateData = () => {
        setLoading(true)
        getRenderDataTypeList(projectUuid, modelUuid).then(res => {
            let data: RenderDataType[] = res.data || []
            setTypeList(data)
            if (data.length > 0) {
                setActiveItemUuid(data[0].uuid)
            }
        }).catch(e => {
            message.error("获取列表失败！")
        }).finally(() => {
            setLoading(false)
        })
    }


    const onDeleteClick = () => {
        if (loading) return
        if (activeItemUuid?.length > 0) {
            setLoading(true)
            deleteRenderDataType(activeItemUuid).then(() => {
                generateData()
            })
        }
    }

    const onAddBtnClick = () => {
        setVisible(true)
        setNameValue("")
    }

    const onConfirmAdd = () => {
        if (loading) return
        let addData: RenderDataType = {
            projectUuid: projectUuid,
            modelUuid: projectUuid,
            name: nameValue,
            isDefault: typeList.length == 0,
            isOutline: false
        }
        addRenderDataType(projectUuid, modelUuid, addData).then(res => {
            let newUuid: string = res.data
            let newData: RenderDataType = {
                id: newUuid,
                uuid: newUuid,
                projectUuid: projectUuid,
                modelUuid: projectUuid,
                name: nameValue,
                isDefault: typeList.length == 0
            }
            typeList.push(newData)
            setTypeList([...typeList])
        }).catch(e => {
            message.error("添加失败！")
        }).finally(() => {
            setVisible(false)
        })
    }

    const uploadRenderData = () => {
        if (!(activeItemUuid?.length > 0)) {
            message.warning("请选择导出类型！")
            return
        }

        setLoading(true)
        let data = getRenderDataJson()
        exportRenderData(activeItemUuid, data).then(res => {
            message.success("导出结束")
        }).catch(e => {
            message.error("导出模型量过多，导出失败！")
        }).finally(() => {
            setLoading(false)
        })
    }

    const onRowRightClick = (e: React.MouseEvent, index: string) => {
        e.preventDefault();
        setCmLeft(e.clientX);
        setCmTop(e.clientY);
        setActiveItemUuid(index)
        setContextMenuVisible(true);
    }

    const updateDefaultConfirm = () => {
        setLoading(true)
        let oldItem = typeList.find(item => item.isDefault)
        let newItem = typeList.find(item => item.uuid == activeItemUuid)
        oldItem.isDefault = false
        newItem.isDefault = true

        updateRenderDataType(oldItem.uuid, oldItem).then(res => {
            return updateRenderDataType(newItem.uuid, newItem)
        }).then(res => {
            generateData()
        }).catch(() => {
            message.error("设置失败！")
        }).finally(() => {
            setContextMenuVisible(false)
        })
    }

    const updateOutlineConfirm = () => {
        setLoading(true)

        updateRenderDataType(activeItemUuid, { isOutline: true }).then(res => {
            let oldItem = typeList.find(item => item.isOutline)
            if (oldItem) {
                return updateRenderDataType(oldItem.uuid, { isOutline: false })
            }
            return null
        }).then(() => {
            generateData()
        }).catch(() => {
            message.error("设置失败！")
        }).finally(() => {
            setContextMenuVisible(false)
        })
    }

    const onClickDownload = () => {
        getProjectDetail(projectUuid).then((resproject) => {
            downloadRenderDataBackup(projectUuid).then((res) => {
                message.success('导出结束');

                const base64Data = res.data;
                const binaryString = atob(base64Data); // 将 Base64 解码为二进制字符串
                const byteArray = new Uint8Array(binaryString.length);

                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }

                const blob = new Blob([byteArray], { type: 'application/json' }); // 创建 Blob 对象
                const url = window.URL.createObjectURL(blob);

                const now = dayjs();
                const formattedDate = now.format('YYYY_MM_DD_HH_mm_ss'); // 格式化文件名

                const a = document.createElement('a');
                a.href = url;
                a.download = `小程序_${resproject.data.name}_${formattedDate}.json`; // 指定下载文件名
                document.body.appendChild(a);
                a.click();
                a.remove();
            }).catch((e) => {
                message.error('导出失败，请重试！');
                console.log('导出失败，请重试！', e)
            }).finally(() => {
                setLoading(false);
            });
        }).catch((e) => {
            message.error('获取项目信息失败，请重试！');
            console.log('获取项目信息失败，请重试！', e)
        });
    }

    /**
     * 点击自动按钮，自动拼装小程序数据，流程如下：
     * 1. 获取所有的特殊图层
     * 2. 根据特殊图层与特殊的图元类型创建所有需要的renderDataType与renderData，有：
     * 3. 获取图元dict
     * 4. 遍历图元dict，对于每一个：
     *  a. 判断是否是特殊图元（BoundingWallT、FloorT|SFloorT、PatrolPointT、MonitorT、SmokeDetectorT、FireHydrantT、FireExtinguisherT、SprayHeadT）
     *  b. 对于墙、板以外的特殊图元，获取对应的renderDataType|renderData，获取renderKey，放入对应的map内
     *  c. 对于墙、板，判断是否属于WLK组，复制一份，拼接0.2透明度获取新renderKey，放入map
     *  d. 分批次将不同的type传到后端添加
     */
    const onClickAuto = async () => {
        setLoading(true)
        let specialLayers: { [key: number]: string[] } = await initSpecialLayer()
        let renderDataTypeMap = initRenderDataMap()
        let wlkGroupUuid = await getWLKGroup()

        const entityDict = TnEngineExtraContext.getInstance().getCurrentViewEditor().entityDict
        const limitMap: { [key: string]: { limit: number, count: number } } = {
            // "patrolPoint": {
            //     count: 0,
            //     limit: 200
            // },
            // "monitor": {
            //     count: 0,
            //     limit: 400,
            // },
            "smokeDetector": {
                count: 0,
                limit: 150,
            },
            // "fireHydrant": {
            //     count: 0,
            //     limit: 200,
            // },
            // "fireExtinguisher": {
            //     count: 0,
            //     limit: 400,
            // },
            "sprayHead": {
                count: 0,
                limit: 150,
            }
        }
        for (let key in entityDict) {
            let entity = entityDict[key]
            if (entity.hidden) {
                continue
            }
            switch (entity.type) {
                case "PatrolPointT": //巡更点
                    let patrolRes = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(patrolRes, "patrolPoint", renderDataTypeMap, limitMap)
                    break;
                case "MonitorT": // 摄像头
                    let monitorRes = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(monitorRes, "monitor", renderDataTypeMap, limitMap)
                    break;
                case "SmokeDetectorT": // 烟感器
                    let smokeRes = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(smokeRes, "smokeDetector", renderDataTypeMap, limitMap)
                    break;
                case "FireHydrantT": // 消火栓
                    let fireHydrantRes = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(fireHydrantRes, "fireHydrant", renderDataTypeMap, limitMap)
                    break;
                case "FireExtinguisherT": // 灭火器
                    let fireExtinguisher = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(fireExtinguisher, "fireExtinguisher", renderDataTypeMap, limitMap)
                    break;
                case "SprayHeadT": // 喷淋头
                    let sprayHeadRes = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(sprayHeadRes, "sprayHead", renderDataTypeMap, limitMap)
                    break;
                case "FloorT":
                case "SFloorT": // 楼板
                    // 判断是否在外轮廓中
                    if (entity.group[GroupType.GROUP]?.some(i => i.includes(wlkGroupUuid))) {
                        let floorRes = getPrimitivePositionsAndColors(entity)
                        putPCListToTypeMap(floorRes, "building", renderDataTypeMap, limitMap)
                    }
                    break;
                case "BoundingWallT": // 墙
                    if (entity.group[GroupType.GROUP]?.some(i => i.includes(wlkGroupUuid))) {
                        let wallRes = getPrimitivePositionsAndColors(entity)
                        putPCListToTypeMap(wallRes, "building", renderDataTypeMap, limitMap)
                    }
                    break;
                default:
                    break;
            }
            // ===========以下处理特殊图层的图元===========
            if (
                specialLayers[SpecialLayerType.escape_guide_arrow]?.includes(entity.layerUuid) ||
                specialLayers[SpecialLayerType.means_of_escape]?.includes(entity.layerUuid)
            ) {
                // 逃生通道
                let escapeRes = getPrimitivePositionsAndColors(entity)
                putPCListToTypeMap(escapeRes, "escapeGuideArrow", renderDataTypeMap, limitMap)
            } else if (specialLayers[SpecialLayerType.floor].includes(entity.layerUuid)) {
                // 楼板
                if (entity.group[GroupType.GROUP]?.some(i => i.includes(wlkGroupUuid))) {
                    let floorRes = getPrimitivePositionsAndColors(entity)
                    putPCListToTypeMap(floorRes, "building", renderDataTypeMap, limitMap)
                }

            }
        }
        // 将建筑变透明放入外壳中
        let buildingType = renderDataTypeMap["building"]
        let outlineType = renderDataTypeMap["outline"]
        if (buildingType?.renderData) {
            for (let key in buildingType.renderData) {
                let newKey = key + "-0.2-opacity"
                let sourceData = buildingType.renderData[key]
                let copyPosition: number[] = []
                let copyColor: number[] = []
                putListAToListB(sourceData.position, copyPosition)
                putListAToListB(sourceData.color, copyColor)
                outlineType.renderData[newKey] = {
                    position: copyPosition,
                    color: copyColor
                }
            }
        }

        let list = []
        for (let key in renderDataTypeMap) {
            list.push(renderDataTypeMap[key])
        }
        for (let key in renderDataTypeMap) {
            let size = getSizeInKB(renderDataTypeMap[key]);
            console.log("组 " + key + " 大小：" + size + " kb")
        }

        await addRenderTypeByData(projectUuid, modelUuid, list)
        generateData()
        setLoading(false)
    }

    const initSpecialLayer = async () => {
        let newSpecialLayers: { [key: number]: string[] } = {};
        let res = await findLayersInProjectUuid(projectUuid, modelUuid)
        let layers: Layer[] = res.data || [];
        layers.forEach((layer) => {
            layer.lock = false;
            layer.hidden = false;
            Object.keys(SpecialLayerNamePrefix).some(key => {
                const prefix = SpecialLayerNamePrefix[key];
                if (layer.name.startsWith(prefix)) {
                    const layerType = SpecialLayerType[key];
                    let arr = [];
                    if (newSpecialLayers[layerType]) arr = [...newSpecialLayers[layerType]];
                    arr.push(layer.uuid);
                    newSpecialLayers[layerType] = arr;
                    return true;
                }
                return false;
            })
        });
        return newSpecialLayers
    }

    const getWLKGroup = async () => {
        let res = await getGroups(projectUuid, modelUuid)
        let data: Group[] = res.data
        // console.log('data', data)
        let wlkGroup = data.find(g => g.name == "WLK")
        return wlkGroup?.uuid
    }

    const initRenderDataMap = () => {
        let res: { [key: string]: RenderDataType } = {}
        let specialKeyList: { key: string, name: string }[] = [
            { key: "patrolPoint", name: "巡更点" },
            { key: "monitor", name: "摄像头" },
            { key: "smokeDetector", name: "烟感器" },
            { key: "fireHydrant", name: "消火栓" },
            { key: "fireExtinguisher", name: "灭火器" },
            { key: "sprayHead", name: "喷淋头" },
            { key: "escapeGuideArrow", name: "逃生通道" },
        ]

        let buildingUuid = genUUID()
        let builldingType: RenderDataType = {
            id: buildingUuid,
            uuid: buildingUuid,
            isDefault: true,
            name: "建筑",
            projectUuid: projectUuid,
            modelUuid: modelUuid,
            renderData: {}
        }
        let outlineUuid = genUUID()
        let outlineType: RenderDataType = {
            id: outlineUuid,
            uuid: outlineUuid,
            name: "外轮廓",
            isDefault: false,
            isOutline: true,
            projectUuid: projectUuid,
            modelUuid: modelUuid,
            renderData: {}
        }
        res["building"] = builldingType
        res["outline"] = outlineType

        for (let i = 0; i < specialKeyList.length; i++) {
            let newUuid = genUUID()
            let newType: RenderDataType = {
                id: newUuid,
                uuid: newUuid,
                name: specialKeyList[i].name,
                projectUuid: projectUuid,
                modelUuid: modelUuid,
                isDefault: false,
                renderData: {}
            }
            res[specialKeyList[i].key] = newType
        }
        return res
    }

    const getPrimitivePositionsAndColors = (primitive: ModelBase) => {

        let singlePrimitives: MeshBaseT[] = []
        getSinglePrimitive(primitive, singlePrimitives)
        const editor = TnEngineExtraContext.getInstance().getCurrentViewEditor()
        const objectRenderBucket = editor.renderControl.objectRenderBucket

        let res: { [key: string]: { positionList: number[], colorList: number[] } } = {}

        for (let i = 0; i < singlePrimitives.length; i++) {
            let midPrimitive = singlePrimitives[i]
            let renderItemDict = midPrimitive.renderItemDict
            for (let key in renderItemDict) {
                let resP: number[] = []
                let resC: number[] = []
                let renderItem = renderItemDict[key]
                let itemKey = renderItem.lastRenderKey
                const renderMaps = objectRenderBucket[itemKey]?.renderMaps || []
                let mapIdx = renderItem.renderGeometryBucketIndex
                if (renderMaps?.length <= mapIdx) {
                    continue;
                }
                let renderMap = renderMaps[mapIdx]
                let buffer: BufferGeometry = renderMap.buffer
                let positions = buffer?.attributes?.position?.array || new Float32Array();
                let colors = buffer?.attributes?.color?.array || new Float32Array();
                for (let j = 0; j < renderItem.size; j++) {
                    resP.push(positions[renderItem.start + j])
                }
                for (let j = 0; j < renderItem.size; j++) {
                    resC.push(colors[renderItem.start + j])
                }
                res[itemKey] = {
                    positionList: resP,
                    colorList: resC
                }
            }
        }
        return res
    }

    const getSinglePrimitive = (primitive: ModelBase, singleList: MeshBaseT[]) => {
        if (primitive.composite) {
            let complexModel = primitive as BlockT | DcalignedT | DclinearT;
            complexModel.getEntities().forEach((item: ModelBase) => {
                item.renderInControl = primitive.renderInControl;
                if (item.composite) {
                    getSinglePrimitive(item, singleList);
                } else {
                    if (item.renderType == "TextureMesh") {
                        singleList.push(item as MeshBaseT)
                    }
                }
            })
        } else {
            if (primitive.renderType == "TextureMesh") {
                singleList.push(primitive as MeshBaseT)
            }
        }
    }

    const putListAToListB = (listA: number[], listB: number[]) => {
        for (let i = 0; i < listA.length; i++) {
            listB.push(listA[i])
        }
    }

    /**
     * 将从 getPrimitivePositionsAndColors 方法获取的positionList和colorList加入对应的renderType中
     * @param data 
     * @param typeKey 
     * @param typeMap 
     */
    const putPCListToTypeMap = (data: { [key: string]: { positionList: number[], colorList: number[] } }, typeKey: string, typeMap: { [key: string]: RenderDataType }, limitMap: { [key: string]: { limit: number, count: number } }) => {
        if (limitMap[typeKey]) {

            if (limitMap[typeKey].count > limitMap[typeKey].limit) {
                return
            }
            limitMap[typeKey].count++
        }
        let matchType = typeMap[typeKey]
        if (!matchType) return
        for (let key in data) {
            let midData = data[key]
            if (!matchType.renderData[key]) {
                matchType.renderData[key] = {
                    position: [],
                    color: []
                }
            }
            putListAToListB(midData.positionList, matchType.renderData[key].position)
            putListAToListB(midData.colorList, matchType.renderData[key].color)
        }
    }

    const getSizeInKB = (obj: any): number => {
        const jsonStr = JSON.stringify(obj);
        const bytes = new TextEncoder().encode(jsonStr).length; // UTF-8 编码字节长度
        const kilobytes = bytes / 1024;
        return Number(kilobytes.toFixed(2));
    };


    return (
        <div className="side-bar-main">
            <SideBarTool
                activeBtnList={[SideBarBtnType.DELETE, SideBarBtnType.ADD]}
                onDeleteBtnClick={onDeleteClick}
                onAddBtnClick={onAddBtnClick}
            />

            <Spin spinning={loading}>
                <div className="body">
                    <div className="title">
                        小程序模型 类型列表
                        <div className="btn" style={{ marginLeft: "auto" }} onClick={() => {
                            onClickDownload()
                        }}>
                            下载
                        </div>
                        <div className="btn" onClick={() => {
                            onClickAuto()
                        }} >
                            自动
                        </div>
                        <div className="btn" onClick={() => { uploadRenderData() }}>
                            导出
                        </div>
                    </div>
                    <div className="list-body">
                        {typeList?.map((item, key) => (
                            <div
                                key={key}
                                className={classNames({
                                    "list-item": true,
                                    "list-item-active": activeItemUuid == item.uuid
                                })}
                                onClick={() => {
                                    setActiveItemUuid(item.uuid)
                                }}
                                onContextMenu={(e) => {
                                    onRowRightClick(e, item.uuid)
                                }}
                            >
                                {item.name}
                                <div className="define">
                                    {item.isDefault && (
                                        <div className="item">
                                            默认
                                        </div>
                                    )}
                                    {item.isOutline && (
                                        <div className="item">
                                            外轮廓
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Spin>

            <DragModal
                title="添加小程序模型类型"
                visible={visible}
                width={500}
                mask
                destroyOnClose
                onClose={() => setVisible(false)}
                wrapClassName="render-data-type-model"
            >
                <div className="model-item">
                    <div className="label">
                        名称
                    </div>
                    <Input value={nameValue} onChange={(e) => {
                        setNameValue(e.target.value)
                    }} />
                </div>
                <div style={{ width: "100%" }}>
                    <Button className="btn" onClick={() => { onConfirmAdd() }}>确认</Button>
                </div>
            </DragModal>

            <ContextMenuFC
                visible={contextMenuVisible}
                left={cmLeft}
                top={cmTop}
                width={140}
                onCancel={() => {
                    setContextMenuVisible(false);
                }}
                wrapperClassname='tn-right-context-menu'
            >
                <div className="btn" onClick={() => { updateDefaultConfirm() }}>
                    置为默认显示类型
                </div>
                <div className="btn" onClick={() => { updateOutlineConfirm() }}>
                    置为外轮廓
                </div>
            </ContextMenuFC>
        </div>
    )
}